// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"VD-z","smallCardRow":"WD-z","largeCardRow":"XD-z","productSearchRow":"YD-z","curatedRow":"ZD-z"};